import { render, staticRenderFns } from "./Tarjeta.vue?vue&type=template&id=13264c39&scoped=true"
import script from "./Tarjeta.vue?vue&type=script&lang=ts"
export * from "./Tarjeta.vue?vue&type=script&lang=ts"
import style0 from "./Tarjeta.vue?vue&type=style&index=0&id=13264c39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13264c39",
  null
  
)

export default component.exports